import { render, staticRenderFns } from "./RecentList.vue?vue&type=template&id=37d667c7&"
import script from "./RecentList.vue?vue&type=script&lang=js&"
export * from "./RecentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports